import * as THREE from "three";
import { MeshPhysicalMaterial } from "three";

export const BoltMaterial = new MeshPhysicalMaterial({
  color: "#363432",
  roughness: 0.9,
  metalness: 0.75,
  clearcoat: 0.5,
  clearcoatRoughness: 0.5,
  side: THREE.DoubleSide,
});
export const PocketLining = new MeshPhysicalMaterial({
  color: "#6C6764",
  roughness: 0.9,
  metalness: 0.75,
  clearcoat: 0.5,
  clearcoatRoughness: 0.5,
  side: THREE.DoubleSide,
});
export const BlackPlastic = new MeshPhysicalMaterial({
  color: "#2c2a28",
  roughness: 0.9,
  metalness: 0.75,
  clearcoat: 0.5,
  clearcoatRoughness: 0.5,
  side: THREE.DoubleSide,
});

export const BlackPowerCoat = new MeshPhysicalMaterial({
  color: "#171614",
  roughness: 0.9,
  metalness: 0.5,
  clearcoat: 0,
  clearcoatRoughness: 0,
});

export const BlackMetal = new MeshPhysicalMaterial({
  color: "#111111",
  roughness: 0.2,
  metalness: 0.75,
  clearcoat: 0,
  clearcoatRoughness: 0,
  side: THREE.DoubleSide,
});
export const Chrome2 = new MeshPhysicalMaterial({
  color: "#ffffff",
  roughness: 0,
  metalness: 0.9,
  side: THREE.DoubleSide,
});
export const Chrome3 = new MeshPhysicalMaterial({
  color: "#ffffff",
  roughness: 0.3,
  metalness: 0.7,
  side: THREE.DoubleSide,
});
export const BlackChrome = new MeshPhysicalMaterial({
  color: 0x615f5d,
  roughness: 0.15,
  metalness: 1,
  side: THREE.DoubleSide,
});

export const PocketMaterial = new MeshPhysicalMaterial({
  color: "#9B784B",
  roughness: 1,
  metalness: 0,
});

export const PaintMaterial = new MeshPhysicalMaterial({
  color: "#230f0f",
  roughness: 0.9,
  metalness: 0.5,
  clearcoat: 0.5,
  clearcoatRoughness: 0.1,
  side: THREE.DoubleSide,
});

export const finishesData = [
  {
    id: "default",
    color: 0xffffff, //optional
    diffuseUrl: null, //optional
    repeat: [1, 1], //optional
    normalUrl: null, //optional
    normalRepeat: [1, 1], //optional
    normalScale: 0, //optional
    ormUrl: null, //optional
    ormRepeat: [1, 1], //optional
    useAo: false, //optional
    useRoughness: false, //optional
    useMetalness: false, //optional
    ior: 1.5, //optional
    clearcoat: 0, //optional
    clearcoatRoughness: 0, //optional
  },
  {
    id: "blackcherry",
    // color: 0x474246,
    color: 0x37202d,
    normalUrl: "textures/body_black_cherry_normal.jpg",
    normalRepeat: [30, 30],
    normalScale: 1,
    roughness: 0.6,
    metalness: 0,
    ior: 1.2232,
    clearcoat: 0.3,
    clearcoatRoughness: 0,
  },
  {
    id: "blackgloss",
    color: 0x010101,
    // normalScale: 0.02,
    roughness: 0,
    metalness: 0.7,
    ior: 1.4976,
    clearcoat: 0.5,
    clearcoatRoughness: 0.1,
  },
  {
    id: "bluegloss",
    // color: 0x001729,
    color: 0x001f32,
    normalUrl: "textures/body_burgundy_marble_normal.jpg",
    normalRepeat: [30, 30],
    normalScale: 1,
    // roughness: 0.175,
    roughness: 0.1,
    // metalness: 0.4,
    metalness: 0.5,
    // metalness: 0.6,
    ior: 1.3373,
    clearcoat: 1,
    clearcoatRoughness: 0,
  },
  {
    id: "bronzegloss",
    color: 0x483410,
    // normalUrl: "textures/body_bronze_gloss_normal.jpg",
    normalUrl: "textures/body_mirror_black_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.1,
    roughness: 0.4,
    metalness: 0.5,
    ior: 1.4927,
    clearcoat: 0.7,
    clearcoatRoughness: 0,
  },
  {
    id: "bronzetextured",
    color: 0xffffff,
    diffuseUrl: "textures/body_bronze_textured_diffuse.jpg",
    repeat: [20, 20],
    normalUrl: "textures/body_bronze_textured_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 1,
    roughness: 0.5,
    metalness: 0,
    ior: 1.4976,
    clearcoat: 0,
    clearcoatRoughness: 0.25,
  },
  {
    id: "burgundygloss",
    color: 0x2f0a0a,
    // normalScale: 0.1,
    roughness: 0.3,
    metalness: 0,
    ior: 1.4976,
    clearcoat: 0.5,
    clearcoatRoughness: 0.1,
  },
  {
    id: "burgundymetallicfeatherededge",
    color: 0x2f0a0a,
    // normalScale: 0.1,
    roughness: 0.3,
    metalness: 0,
    ior: 1.4976,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "burgundymarble",
    color: 0x2f0a0a,
    normalUrl: "textures/body_burgundy_marble_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 1,
    roughness: 0.2,
    metalness: 0.3,
    ior: 1.6047,
    clearcoat: 0.05,
    clearcoatRoughness: 0.1,
  },
  {
    id: "champagnefeatherededge",
    // color: 0xab9b83,
    color: 0x887c68,
    // diffuseUrl: "textures/body_gray_marble_diffuse.jpg",
    // repeat: [20, 20],
    // normalUrl: "textures/body_gray_marble_normal.jpg",
    // normalRepeat: [20, 20],
    // normalScale: 0.4,
    roughness: 0.4,
    metalness: 0.01,
    ior: 1.4976,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "champagnegloss",
    // color: 0xab9b83,
    // color: 0x887c68,
    color: 0xa09175,
    // diffuseUrl: "textures/body_gray_marble_diffuse.jpg",
    repeat: [20, 20],
    // normalUrl: "textures/body_gray_marble_normal.jpg",
    normalRepeat: [20, 20],
    // normalScale: 0.2,
    roughness: 0.4,
    metalness: 0.5,
    ior: 1.4976,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "champagnemarble",
    color: 0xab9b83,
    // color: 0x000003,
    // diffuseUrl: "textures/body_gray_marble_diffuse.jpg",
    // repeat: [15, 15],
    normalUrl: "textures/body_gray_marble_normal.jpg",
    normalRepeat: [15, 15],
    // normalScale: 0.1,
    normalScale: 0.2,
    // roughness: 0.6,
    roughness: 0.275,
    // metalness: 0.4,
    metalness: 0.8,
    ior: 1.4927,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "emeraldgreenfeatherededge",
    color: 0x182e05,
    // normalUrl: "textures/body_green_marble_normal.jpg",
    // normalRepeat: [20, 20],
    // normalScale: 0.7,
    roughness: 0.6,
    // metalness: 0.5,
    ior: 1.4976,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "emeraldgreen",
    color: 0x182e05,
    normalUrl: "textures/body_green_marble_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.125,
    roughness: 0.5,
    metalness: 0.75,
    ior: 2.3333,
    clearcoat: 1,
    clearcoatRoughness: 0,
  },
  {
    id: "emeraldmettalic",
    color: 0x182e05,
    normalUrl: "textures/body_green_marble_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.5,
    roughness: 0,
    metalness: 1,
    ior: 1.2232,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "forestmistgloss",
    // color: 0x072900,
    // color: 0x757775,
    color: 0x556163,
    // normalScale: 0.1,
    // roughness: 0.3,
    roughness: 0.3,
    // metalness: 0.6,
    metalness: 0.7,
    ior: 1.4976,
    // clearcoat: 0.7,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "graycharcoal",
    color: 0x929292,
    // normalScale: 0.1,
    roughness: 0.3,
    metalness: 0.5,
    ior: 1.4976,
    clearcoat: 0.7,
    clearcoatRoughness: 0,
  },
  {
    id: "graycharcoalfeatherededge",
    color: 0x929292,
    // normalScale: 0.1,
    roughness: 0.2,
    metalness: 0.7,
    ior: 1.9476,
    clearcoat: 0,
    clearcoatRoughness: 0.25,
  },
  {
    id: "graymarble",
    color: 0x59544c,
    diffuseUrl: "textures/body_gray_marble_diffuse.jpg",
    repeat: [20, 20],
    normalUrl: "textures/body_gray_marble_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.25,
    roughness: 0.4,
    metalness: 0.8,
    ior: 1.4927,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "graygloss",
    color: 0x59544c,
    // normalScale: 0.1,
    roughness: 0.3,
    metalness: 0,
    ior: 1.4976,
    clearcoat: 0.5,
    clearcoatRoughness: 0.1,
  },
  {
    id: "greenmarble",
    // color: 0x112e0d,
    color: 0x102d0c,
    normalUrl: "textures/body_green_marble_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.1,
    roughness: 0.2,
    metalness: 0.85,
    ior: 2.3333,
    clearcoat: 1,
    clearcoatRoughness: 0,
  },
  {
    id: "greengloss",
    color: 0x112e0d,
    // normalScale: 0.5,
    roughness: 0.2,
    metalness: 1,
    ior: 2.3333,
    clearcoat: 1,
    clearcoatRoughness: 0,
  },
  {
    id: "mirrorblack",
    color: 0x1d1c1a,
    // normalUrl: "textures/body_mirror_black_normal.jpg",
    normalRepeat: [30, 30],
    // normalScale: 1,
    roughness: 0.4,
    metalness: 0.1,
    ior: 1.6425,
    clearcoat: 0.3,
    clearcoatRoughness: 0,
  },
  {
    id: "texturedblack",
    color: 0x010101,
    normalUrl: "textures/body_textured_black_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.5,
    roughness: 0.10,
    metalness: 0.625,
    ior: 1.381,
    clearcoat: 0.1,
    clearcoatRoughness: 0.1,
  },
   {
    id: "texturedwhite",
    color: 0xd8cfb7,
    // normalScale: 0.1,
    roughness: 1,
    metalness: 0.1,
    ior: 1.4976,
    clearcoat: 0.5,
    clearcoatRoughness: 0.1,
  },
  // {
  //   id: "texturedwhite",
  //   color: 0xf4efef,
  //   normalUrl: "textures/body_textured_black_normal.jpg",
  //   normalRepeat: [20, 20],
  //   normalScale: 0.75,
  //   roughness: 0.2,
  //   metalness: 0.1,
  //   ior: 1.381,
  //   clearcoat: 1,
  //   clearcoatRoughness: 0.1,
  // },
  {
    id: "azuresky",
    color: 0x6094D8,
    normalUrl: "textures/body_textured_black_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.25,
    roughness: 0.4,
    metalness: 0.32,
    ior: 1.381,
    clearcoat: 0.5,
    clearcoatRoughness: 0.25,
  },
  {
    id: "frontiersage",
    color: 0xAFCED2,
    normalUrl: "textures/body_textured_black_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.5,
    roughness: 0.2,
    metalness: 0.4,
    ior: 1.381,
    clearcoat: 0.1,
    clearcoatRoughness: 0.1,
  },
  {
    id: "icywhite",
    color: 0xEFEEF3,
    normalUrl: "textures/body_textured_black_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.25,
    roughness: 0.5,
    metalness: 0.32,
    ior: 1.381,
    clearcoat: 1,
    clearcoatRoughness: 0.1,
  },
  {
    id: "canvasbeige",
    color: 0xB1A79E,
    normalUrl: "textures/body_textured_black_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.75,
    roughness: 0.2,
    metalness: 0.1,
    ior: 1.381,
    clearcoat: 1,
    clearcoatRoughness: 0.1,
  },
  {
    id: "texturedgranite",
    color: 0xffffff,
    diffuseUrl: "textures/body_textured_granite_diffuse.jpg",
    repeat: [20, 20],
    normalUrl: "textures/body_textured_granite_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 1,
    roughness: 0.5,
    metalness: 0,
    ior: 1.4976,
    clearcoat: 0,
    clearcoatRoughness: 0.25,
  },
  {
    id: "whitegloss",
    color: 0xd8cfb7,
    // normalScale: 0.1,
    roughness: 1,
    metalness: 0.1,
    ior: 1.4976,
    clearcoat: 0.5,
    clearcoatRoughness: 0.1,
  },
  {
    id: "whitemarble",
    color: 0xd4d0bc,
    // color: 0xcdc9b1,
    normalUrl: "textures/body_smooth_marble_normal.jpg",
    normalRepeat: [20, 20],
    normalScale: 0.5,
    roughness: 1,
    metalness: 0,
    ior: 1.2707,
    clearcoat: 0,
    clearcoatRoughness: 1,
  },
  {
    id: "beigevelour",
    color: 0xbfbcbf,
    diffuseUrl: "textures/interior_biege_velour_diffuse.jpg",
    repeat: [15, 15],
    normalUrl: "textures/interior_biege_velour_normal.jpg",
    normalRepeat: [15, 15],
    normalScale: 0.5,
    roughness: 1,
    metalness: 0,
  },
  {
    id: "camelfabric",
    color: 0xdddddd,
    diffuseUrl: "textures/interior_camel_fabric_diffuse.jpg",
    repeat: [15, 15],
    // normalUrl: "textures/interior_camel_fabric_normal.jpg",
    // normalRepeat: [20, 20],
    // normalScale: 0.5,
    roughness: 1,
    metalness: 0,
    ior: 1.2232,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "grayfabric",
    color: 0x8f8f8f,
    diffuseUrl: "textures/interior_gray_truckliner_diffuse.jpg",
    repeat: [15, 15],
    // normalUrl: "textures/interior_gray_truckliner_normal.jpg",
    // normalRepeat: [20, 20],
    // normalScale: 0.5,
    // roughnessUrl: "textures/interior_gray_truckliner_roughness.jpg",
    // roughnessRepeat: [20, 20],
    // metalnessUrl: "textures/interior_gray_truckliner_metallic.jpg",
    // metalnessRepeat: [20, 20],
    roughness: 1,
    metalness: 0,
  },
  {
    id: "silvervelour",
    color: 0xd0d0d8,
    diffuseUrl: "textures/interior_grey_velour_diffuse.jpg",
    repeat: [30, 30],
    normalUrl: "textures/interior_grey_velour_normal.jpg",
    normalRepeat: [30, 30],
    normalScale: 1,
    roughness: 1,
    metalness: 0,
  },
  {
    id: "camelfauxleather",
    color: 0xdddddd,
    diffuseUrl: "textures/interior_camel_faux_leather_diffuse.png",
    repeat: [10, 10],
    normalUrl: "textures/interior_camel_faux_leather_normal.jpg",
    normalRepeat: [10, 10],
    normalScale: 0.5,
    roughness: 1,
    metalness: 1,
    ior: 1.2232,
    clearcoat: 0,
    clearcoatRoughness: 0,
  },
  {
    id: "grayfauxleather",
    color: 0x8f8f8f,
    diffuseUrl: "textures/interior_grey_faux_leather_diffuse.png",
    repeat: [10, 10],
    normalUrl: "textures/interior_grey_faux_leather_normal.jpg",
    normalRepeat: [10, 10],
    // normalScale: 0.5,
    // roughnessUrl: "textures/interior_gray_truckliner_roughness.jpg",
    // roughnessRepeat: [20, 20],
    // metalnessUrl: "textures/interior_gray_truckliner_metallic.jpg",
    // metalnessRepeat: [20, 20],
    roughness: 1,
    metalness: 0,
  },
  {
    id: "blackchromehardware",
    color: 0x615f5d,
    // normalScale: 1,
    roughness: 0.15,
    metalness: 1,
  },
  {
    id: "brasshardware",
    color: 0xd6b168,
    // normalScale: 1,
    roughness: 0.2,
    metalness: 1,
  },
  {
    id: "chromehardware",
    color: 0xffffff,
    // normalScale: 1,
    roughness: 0,
    metalness: 0.9,
  },
  {
    id: "goldhardware",
    color: 0xdeba59,
    // normalScale: 1,
    roughness: 0.25,
    metalness: 1,
  },
  {
    id: "woodgrainvinyl",
    color: 0xdddddd,
    diffuseUrl: "textures/shelf_woodgrain_vinyl_diffuse.jpg",
    normalUrl: "textures/shelf_woodgrain_vinyl_normal.jpg",
    roughnessUrl: "textures/shelf_woodgrain_vinyl_roughness.jpg",
    repeat: [5, 5],
    normalRepeat: [5, 5],
    roughnessRepeat: [5, 5],
    useAo: false,
    useRoughness: true,
    useMetalness: true,
    roughness: 1,
    metalness: 0,
    normalScale: 2,
  },

  //#endregion shelf_wood finishes

  // Lock_mechanical
  {
    id: "Lock_mechanical",
    diffuseUrl: "textures/mechanical_lock.jpg",
    normalUrl: "textures/mechanical_normal.jpg",
    ormUrl: "textures/mechanical_lock_orm.png",
    useAo: true,
    useRoughness: true,
    useMetalness: true,
  }, // Lock_mechanical
  {
    id: "Lock_mechanical_large",
    diffuseUrl: "textures/mechanical_lock_large.jpg",
    // normalUrl: "textures/mechanical_normal_large.jpg",
    ormUrl: "textures/mechanical_lock_orm_large.png",
    useAo: true,
    useRoughness: true,
    useMetalness: true,
  },
  // Lock securam_topit
  {
    id: "Lock_securam_toplit",
    diffuseUrl: "textures/securam_toplit.jpg",
    ormUrl: "textures/centurion/32/securam_toplit.png",
    useAo: true,
    useRoughness: true,
    useMetalness: true,
  },
  // Lock securam_topit dialpad
  {
    id: "Lock_securam_toplit_dialpad",
    color: 0xffffff,
    diffuseUrl: "textures/securam_toplit.jpg",
    // ormUrl: "textures/centurion/32/securam_toplit.png",
    ormRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetalness: false,
    roughness: 1,
    metalness: 0,
  },
  // securam_prologic
  {
    id: "Lock_securam_prologic",
    diffuseUrl: "textures/lock_securam_prologic_diffuse.jpg",
    normalUrl: "textures/lock_securam_prologic_normal.jpg",
    ormUrl: "textures/lock_securam_prologic_orm.png",
    repeat: [1, 1],
    normalRepeat: [1, 1],
    ormRepeat: [1, 1],
    useAo: true,
    useRoughness: true,
    useMetalness: true,
  },
  //securam_prologic dialpad
  {
    id: "Lock_securam_prologic_dialpad",
    color: 0xcccccc,
    diffuseUrl: "textures/lock_securam_prologic_diffuse.jpg",
    repeat: [1, 1],
    ormRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetalness: false,
    roughness: 1,
    metalness: 0,
  },
];
